<div class="container-fluid">
    <div class="row mb-3">
        <div class="col d-flex justify-content-between align-items-center">
            <h3>Seleccione una ubicación</h3>
            <button class="btn" type="button" (click)="dialogRef.close()">X Cerrar</button>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col">
            <ul class="list-group">
                <li *ngFor="let result of data.results" class="list-group-item list-group-item-action" (click)="selectResult(result)">
                    {{ result.name }}
                </li>
            </ul>
        </div>
    </div>
    <div class="row mb-3">
        <div class="col d-flex justify-content-end">
            <button type="button" class="btn btn-primary" (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</div>
